import generalSettings from "@apis/generalSettings";
import React, { useCallback, useEffect, useState } from "react";

const useModulePercentage = () => {
  const [existing, setExisting] = useState<any | null>(null);
  const [infoFields, setInfoFields] = useState<string[]>([]);

  const fetchModuleWisePercentage = useCallback(async () => {
    const data = await generalSettings.getByKey({
      id: "business-rule",
      state: "modulesPercentage",
      showErr: false,
    });
    if (data) {
      setExisting(data);
      const parsed = data?.infos ?? {};
      const infoKeys = Object.keys(parsed);
      setInfoFields(infoKeys);
    }
  }, []);

  useEffect(() => {
    fetchModuleWisePercentage();
  }, [fetchModuleWisePercentage]);

  return { existing, infoFields };
};

export default useModulePercentage;
